
import Vue from "vue";

interface NotFoundComponentData {
	errCode: string;
	errMessage: string;
}
export default Vue.extend({
	page: {
		title: "404",
		meta: [
			{
				name: "description",
				content: "404",
			},
		],
	},
	props: {
		resource: {
			type: String,
			default: "The page you requested",
		},
		code: {
			type: String,
			default: "",
		},
		message: {
			type: String,
			default: "",
		},
		theme: String,
	},
	data(): NotFoundComponentData {
		return {
			errCode: this.code,
			errMessage: this.message ? this.message : `${this.resource} does not exist`,
		};
	},
});
